export const Arr_DeclarationsInfo = [
  //-------------------------------------------------------------------------
  //Arr_DeclarationsInfo
  //Medical
  {
    Page: "DeclarationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Agree",
    name: "Declaration_Agree",
    selectValues: ["Yes"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "DeclarationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Blood products",
    name: "Declaration_blood_products",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Consent for use of blood products/ transfusions if required for
        emergency and urgent treatment
      </p>
    ),
  },
  {
    Page: "DeclarationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Over-the-counter",
    name: "Declaration_otc",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>Consent for student to take over-the-counter medication if required</p>
    ),
  },
  //Filming
  {
    Page: "DeclarationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Parent/ Legal Guardian",
    name: "Declaration_parent_filming",
    selectValues: [
      "Yes, I give my informed consent",
      "No, I do not provide consent",
    ],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "DeclarationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Student",
    name: "Declaration_student_filming",
    selectValues: [
      "Yes, I give my informed consent",
      "No, I do not provide consent",
    ],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  //behavior
  {
    Page: "DeclarationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Code of Conduct",
    name: "Declaration_student_code_of_conduct",
    selectValues: ["Yes"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        <a href="https://docsend.com/view/mu8aitkrsx7j724a" target="_blank">
          <strong>Student Code of Conduct</strong>
        </a>
      </p>
    ),
  },
  {
    Page: "DeclarationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Behaviour Matrix",
    name: "Declaration_behaviour_matrix",
    selectValues: ["Yes"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        <a href="https://docsend.com/view/armfi9g4vxsz289k" target="_blank">
          <strong>Behaviour Matrix</strong>
        </a>
      </p>
    ),
  },
  {
    Page: "DeclarationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Film and Photography",
    name: "Declaration_filming_and_photography",
    selectValues: ["Yes"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        <a href="https://docsend.com/view/dcfewegqmsbsc8d9" target="_blank">
          <strong>Filming and Photography Policy</strong>
        </a>
      </p>
    ),
  },
  {
    Page: "DeclarationsInfo",
    TextField: "SelectFieldForObjectState",
    label: "Online Safety",
    name: "Declaration_online_safety",
    selectValues: ["Yes"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        <a href="https://docsend.com/view/7p3z9tbb2ptpedpb" target="_blank">
          <strong>Online Safety</strong>
        </a>
      </p>
    ),
  },
];
